import styled from 'styled-components';

import { breakpoints } from '../../theme';

interface RelativeInputProps {
  width?: string;
  height?: string;
  mobWidth?: number;
  margin?: string;
  overflow?: string;
  border?: string;
  maxWidth?: string;
}

export const RelativeInputDiv = styled.div<RelativeInputProps>`
  border-radius: 32px;
  overflow: ${({ overflow }) => overflow || undefined};
  border: ${({ border }) => border || undefined};
  &:focus {
    outline: none;
    box-shadow: 0px 0px 10px #c4c4c4;
  }
  position: relative;
  width: ${({ width }) => (width ? width : undefined)};
  height: ${({ height }) => (height ? height : undefined)};
  margin: ${({ margin }) => (margin ? margin : undefined)};

  max-width: ${({ maxWidth }) => maxWidth};
  @media (${breakpoints.lg}) {
    width: 100%;
  }
`;
